/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import PlanetaryAlignmentCapturePage from './pages/PlanetaryAlignmentCapturePage';
import './index.css';

// The /capture/* pages are loaded headlessly by the screenshot Lambda and must
// render without the app shell — keep them outside the router (B-048).
const getPageComponent = (): React.ReactElement => {
  const path = window.location.pathname;

  if (path === '/capture/planetary-alignment') {
    return <PlanetaryAlignmentCapturePage />;
  }

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {getPageComponent()}
  </React.StrictMode>
);

